import {
  BillingSubType,
  BillingType,
} from "routes/Base/Admin/MarketSettings/List/BillingTypes/types"

import { http } from "./http"

export const fetchBillingTypes = async (_key: string) => {
  const { data } = await http
    .get(`billing-types`)
    .json<{ data: BillingType[] }>()
  return data
}

export const patchBillingType = async (
  pld: Partial<BillingType>,
): Promise<BillingType> => {
  const { id, ...data } = pld
  return (await http.patch(`billing-types/${pld.id}`, { json: data })) as any
}

export const createBillingSubType = async (pld: Partial<BillingSubType>) => {
  const json = pld
  const res = await http.post("billing-subtypes", { json }).json()
  return res as Partial<BillingSubType>
}

export const patchBillingSubType = async (
  pld: Partial<BillingSubType>,
): Promise<BillingSubType> => {
  const { id, ...data } = pld
  return http.patch(`billing-subtypes/${id}`, { json: data }).json()
}

export const fetchBillingSubTypes = async (_key: string, params: string) => {
  const searchParams = new URLSearchParams(params)
  const { data } = await http(`billing-subtypes`, { searchParams }).json<{
    data: BillingSubType[]
  }>()
  return data
}
